import React, { useState } from "react";
import { Col, ListGroup, Row, Button, Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import IndicatorPreviousSupport from "./sections/sectionsIndicatorsEntities/IndicatorPreviousSupport.js";
import IndicatorOpinionIssuer from "./sections/sectionsIndicatorsEntities/IndicatorOpinionIssuer.js";
import IndicatorMCESupport from "./sections/sectionsIndicatorsEntities/IndicatorMCESupport.js";
import IndicatorComplementaryActivities from "./sections/sectionsIndicatorsEntities/IndicatorComplementaryActivities.js";

import ExportDialog from "./sections/utils/ExportDialog";
import ExportLoadingModal from "./sections/utils/ExportLoadingModal";

import { exportAllEntitiesExcelsZip } from "./sections/utils/exportAllEntitiesPage.js";

const INDICATOR_SECTIONS = [
  { id: "apoiosPrevios", label: "Apoios Prévios" },
  { id: "emissoraDeParecer", label: "Emissora De Parecer" },
  { id: "apoiosMCE", label: "Apoios MCE" },
  { id: "complementares", label: "Atividades Complementares" },
];

export default function IndicatorsEntitiesPage() {
  const [activeSection, setActiveSection] = useState("apoiosPrevios");
  const [showExportAll, setShowExportAll] = useState(false);

  const [exporting, setExporting] = useState(false);
  const [zipPct, setZipPct] = useState(null);
  const [subtitleId, setSubtitleId] = useState(
    "indicator.exportar.todos.modal.preparing"
  );
  const [subtitleValues, setSubtitleValues] = useState(undefined);

  const renderActiveSection = () => {
    switch (activeSection) {
      case "apoiosPrevios":
        return <IndicatorPreviousSupport />;
      case "emissoraDeParecer":
        return <IndicatorOpinionIssuer />;
      case "apoiosMCE":
        return <IndicatorMCESupport />;
      case "complementares":
        return <IndicatorComplementaryActivities />;
      default:
        return null;
    }
  };

  const handleExport = () => setShowExportAll(true);

  const runWithLoading = async (fn) => {
    setExporting(true);
    setZipPct(null);
    setSubtitleId("indicator.exportar.todos.modal.preparing");
    setSubtitleValues(undefined);
    try {
      await fn({
        onZipProgress: (p) => {
          setZipPct(p);
          setSubtitleId("indicator.exportar.todos.modal.zipping");
          setSubtitleValues(undefined);
        },
      });
    } finally {
      setExporting(false);
      setZipPct(null);
      setSubtitleId("indicator.exportar.todos.modal.preparing");
      setSubtitleValues(undefined);
    }
  };

  return (
    <Container className="pb-5">
      <div className="mx-3 my-4">
        <Row className="align-items-center mb-4">
          <Col md={{ span: 8, offset: 2 }}>
            <h3 className="mb-0">
              <FormattedMessage id="indicators.monitoring.entities.title" />
            </h3>
          </Col>
          <Col md={2} className="text-end">
            <Button
              variant="outline-primary"
              onClick={handleExport}
              style={{ fontSize: "1rem", padding: "0.6rem 1.2rem" }}
            >
              <FormattedMessage id="indicators.export" />
            </Button>
          </Col>
        </Row>

        <Row>
          <Col md={2}>
            <ListGroup variant="flush" className="border-0">
              {INDICATOR_SECTIONS.map((section) => {
                const isActive = activeSection === section.id;
                return (
                  <ListGroup.Item
                    key={section.id}
                    action
                    onClick={() => setActiveSection(section.id)}
                    className={`indicator-tab ${isActive ? "active-tab" : ""}`}
                  >
                    <FormattedMessage
                      id={`indicator.menu.${section.id}`}
                      defaultMessage={section.label}
                    />
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          </Col>
          <Col md={10}>
            <div
              className="p-3"
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                backgroundColor: "white",
              }}
            >
              {renderActiveSection()}
            </div>
          </Col>
        </Row>

        <ExportDialog
          show={showExportAll}
          onHide={() => setShowExportAll(false)}
          options={[
            {
              onClick: async () => {
                try {
                  await runWithLoading((progress) =>
                    exportAllEntitiesExcelsZip(
                      "indicadores_entidades_de_acompanhamento_excels.zip",
                      progress
                    )
                  );
                  setShowExportAll(false);
                } catch (e) {
                  console.error("[Entities Export All Excels] falhou:", e);
                  alert("Falha ao gerar ZIP com Excels: " + (e?.message || e));
                }
              },
              filename: "indicadores_entidades_de_acompanhamento_excels.zip",
              zipInnerType: "xlsx",
            },
          ]}
        />

        <ExportLoadingModal
          show={exporting}
          titleId="indicator.exportar.todos.modal.title"
          titleDefault="A gerar ZIP de indicadores..."
          subtitleId={subtitleId}
          subtitleDefault="A preparar ficheiros..."
          subtitleValues={subtitleValues}
          percent={zipPct}
          size="sm"
        />
      </div>
    </Container>
  );
}
